export default "__VITE_ASSET__DBm9jSCj__"